import { type YupAnyObjectSchema } from '@framework/validation/YupObjectSchema.ts';
import { deserializeFormValues } from './deserializeFormValues.tsx';
import { type ISerializedFormSectionValue } from './ISerializedFormSectionValue.ts';

/**
 * Deserializza e mappa i dati delle sezioni fornite dal BE, trasformandole in un oggetto:
 * {
 *  "<id-sezione>": {...valori},
 *  "<id-sezione>": {...valori},
 * ...
 * }
 */
export function deserializeFormSectionsValues(
  validationSchema: YupAnyObjectSchema,
  values: ISerializedFormSectionValue[] | null | undefined,
) {
  if (!values) return {};
  if (!validationSchema) return {};

  const data = values.map(v => v.valori ?? {});

  return deserializeFormValues(validationSchema, { values: data });
}
